/**
 * Chart Theme Helper
 *
 * Provides centralized theme configuration for AG Charts across the application.
 * This ensures consistent theming and makes it easy to update chart themes globally.
 */

/**
 * Dark theme configuration with transparent background
 * This allows charts to inherit the dashboard's background color in dark mode
 */
export const quartzDarkChartTheme = {
  baseTheme: 'ag-default-dark',
  overrides: {
    common: {
      background: {
        fill: 'transparent',
      },
    },
  },
};

/**
 * Light theme configuration with transparent background
 * This allows charts to inherit the dashboard's background color in light mode
 */
export const quartzLightChartTheme = {
  baseTheme: 'ag-default',
  overrides: {
    common: {
      background: {
        fill: 'transparent',
      },
    },
  },
};

/**
 * Get the appropriate chart theme based on the application theme
 *
 * @param {Object} theme - The theme object from Redux store (with className property)
 * @returns {string|Object} - Returns 'ag-default' for light theme or quartzDarkChartTheme for dark theme
 *
 * @example
 * import { getChartTheme } from '../../../shared/components/chart/chartThemeHelper';
 *
 * const theme = useSelector(store => store.theme);
 * const chartOptions = {
 *   theme: getChartTheme(theme),
 *   data: myData,
 *   // ... other options
 * };
 */
export function getChartTheme(theme) {
  const isLightTheme = theme?.className?.endsWith('light');
  return isLightTheme ? quartzLightChartTheme : quartzDarkChartTheme;
}
